module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "menu",
    staticClass: "main-menu",
    class: _vm.stateClass
  }, [_c('button', {
    staticClass: "main-menu__open",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.open
    }
  }), _c('button', {
    staticClass: "main-menu__close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }), _c('ul', {
    staticClass: "main-menu__list"
  }, [_c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    staticClass: "main-menu__link main-menu__home",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("ACCUEIL")])], 1), _c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    staticClass: "main-menu__link",
    attrs: {
      "to": "/progress"
    }
  }, [_vm._v("APPRENDRE")])], 1), _c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    staticClass: "main-menu__link",
    attrs: {
      "to": "/create"
    }
  }, [_vm._v("CRÉER")])], 1), _c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    staticClass: "main-menu__link",
    attrs: {
      "to": "/explore"
    }
  }, [_vm._v("JOUER")])], 1), _c('li', {
    staticClass: "main-menu__item"
  }, [(!_vm.user) ? _c('a', {
    staticClass: "main-menu__link connectionLink illustrated-link log-in-link",
    on: {
      "click": function($event) {
        _vm.isAuthenticationModalVisible = true
      }
    }
  }, [_vm._v("SE CONNECTER")]) : _c('a', {
    staticClass: "main-menu__link connectionLink",
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("SE DÉCONNECTER")])]), (_vm.user) ? _c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    staticClass: "main-menu__link",
    attrs: {
      "to": _vm.getUserIDLink
    }
  }, [_vm._v("MON COMPTE")])], 1) : _vm._e()]), (_vm.isAuthenticationModalVisible) ? _c('authentication-modal', {
    on: {
      "close": function($event) {
        _vm.isAuthenticationModalVisible = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-112ce1f5!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/MainMenu.vue
// module id = 581
// module chunks = 2